<template>
    <div class="container-fluid">
        <h1>{{ $t('apiSettings.titleOrganizationApiSettings') }}</h1>
        <br />
        <b-form
            v-if="!isLoading"
            ref="apiSettingsForm"
            name="apiSettingsForm"
            v-on:submit.prevent="$_onSubmit"
            class="pb-5"
        >
            <div class="form-group">
                <div class="col-md-6">
                    <!--Name-->
                    <x-input
                        id="orgApiSettingsName"
                        type="text"
                        :text="this.$t('apiSettings.nameTitle')"
                        v-model="orgApiSettings.apiName"
                        :disabled="true"
                        :maxlength="50"
                    >
                    </x-input>
                    <!--API-key-->
                    <div v-if="editUrl" class="mt-3">
                        <x-input
                            v-if="showBaseUrl"
                            type="text"
                            :text="this.$t('apiSettings.baseUrlTitle')"
                            :disabled="true"
                            v-model="orgApiSettings.baseUrl"
                        />
                        <x-input
                            type="text"
                            :text="urlTitle"
                            v-model="orgApiSettings.url"
                        />
                    </div>
                </div>
                <!-- Stuf specific fields -->
                <div v-if="apiTypeSetting.hasStufFields" class="mt-3">
                    <div
                        v-if="controlDataRecords.length === 0"
                        class="col-md-6"
                    >
                        <x-input
                            type="text"
                            :text="
                                this.$t('apiSettings.receiverApplicationName')
                            "
                            :required="controlDataRecords.length === 0"
                            v-model="orgApiSettings.receiverApplicationName"
                        />
                        <x-input
                            type="text"
                            :text="
                                this.$t('apiSettings.receiverOrganizationName')
                            "
                            v-model="orgApiSettings.receiverOrganizationName"
                        />
                        <x-input
                            type="text"
                            :text="
                                this.$t(
                                    'apiSettings.receiverAdministrationName'
                                )
                            "
                            v-model="orgApiSettings.receiverAdministration"
                        />
                        <x-input
                            type="text"
                            :text="this.$t('apiSettings.senderApplicationName')"
                            :required="controlDataRecords.length === 0"
                            v-model="orgApiSettings.senderApplicationName"
                        />
                        <x-input
                            type="text"
                            :text="
                                this.$t('apiSettings.senderOrganizationName')
                            "
                            required
                            v-model="orgApiSettings.senderOrganizationName"
                        />
                        <x-input
                            type="text"
                            :text="
                                this.$t('apiSettings.senderAdministrationName')
                            "
                            v-model="orgApiSettings.senderAdministration"
                        />
                    </div>
                    <div v-else class="col-md-12">
                        <!-- Overview Table -->
                        <b-table
                            id="cooperation-overview"
                            striped
                            hover
                            small
                            outlined
                            bordered
                            v-show="!isLoading"
                            @row-clicked="$_onEditRecord($event)"
                            :tbody-tr-class="$_rowClass"
                            :items="controlDataRecords"
                            :fields="fields"
                            :sort-by.sync="sortBy"
                            sort-icon-left
                        >
                            <!-- Delete button -->
                            <template v-slot:cell(delete)="row">
                                <div class="d-flex justify-content-center">
                                    <a
                                        href="#"
                                        class="delete"
                                        @click="$_onDeleteRecord(row.item)"
                                        :title="$t('btnDeleteLabel')"
                                    >
                                        <em
                                            class="fas fa-times"
                                            aria-hidden="true"
                                        ></em>
                                    </a>
                                </div>
                            </template>
                        </b-table>
                    </div>
                    <b-button
                        id="addControlDataRecord"
                        variant="primary"
                        class="d-flex align-items-center"
                        :disabled="isSaving"
                        @click="$_onAddRecord()"
                    >
                        {{ $t('apiSettings.addControlData') }}
                    </b-button>
                </div>
                <div class="col-md-6">
                    <div v-if="showCertificate" class="mt-3">
                        <label for="orgApiSettingsCertificate">{{
                            $t('apiSettings.certificate')
                        }}</label>
                        <!--Certificate-->
                        <certificate-loader
                            id="orgApiSettingsCertificate"
                            :name="this.$t('apiSettings.certificateTitle')"
                            :certStatus="certStatus"
                            :certSelected="certSelected"
                            @input="$_onSelectedCertificate"
                            @loadFileValidState="$_onLoadFileValidState"
                        >
                        </certificate-loader>
                        <br />
                        <!--Certificate password-->
                        <username-password
                            :hideUsername="true"
                            :required="true"
                            :password="orgApiSettings.certificatePass"
                            @inputchanged="$_onInputPassword"
                            :pwIsSaved="isSaving"
                            :pwtogglevisible="showEyeIcon"
                        >
                        </username-password>
                        <br />
                        <x-input
                            type="text"
                            :readonly="true"
                            :text="
                                this.$t('apiSettings.certificateExpirationDate')
                            "
                            v-model="orgApiSettings.certificateExpirationDate"
                        >
                        </x-input>
                    </div>
                    <div v-if="apiTypeSetting.hasApiKey" class="mt-3">
                        <x-input
                            id="orgApiSettingsApiKey"
                            type="text"
                            :required="true"
                            :text="this.$t('apiSettings.apiKeyTitle')"
                            v-model="orgApiSettings.apiKey"
                            @input="$_onInputApiKey"
                            :maxlength="255"
                            :autofocus="true"
                        >
                        </x-input>
                        <label for="ApiKeyEndDatePicker"
                            >{{ $t('apiSettings.apiKeyEndDateTitle') }}
                        </label>
                        <b-form-datepicker
                            id="ApiKeyEndDatePicker"
                            v-model="orgApiSettings.apiKeyEndDate"
                            class="mb-2"
                            :locale="getLocale"
                            :label-no-date-selected="
                                this.$t('apiSettings.apiKeyEndDatePicker')
                            "
                            reset-button
                        ></b-form-datepicker>
                    </div>
                    <!-- Woz -->
                    <div v-if="isWoz" class="mt-3 mb-5">
                        <dual-listbox
                            :titleAvailable="
                                $t('apiSettings.kadastraleGemeenteAvailable')
                            "
                            :titleSelected="
                                $t('apiSettings.kadastraleGemeenteSelected')
                            "
                            :itemsAvailable="availableGemCodes"
                            :itemsSelected="selectedGemCodes"
                            :items="kadastraleGemeenteCodes"
                            itemDisplayName="text"
                            :showUpDownButtons="false"
                            @update="$_updateKadastraleGemeenteCodes($event)"
                        >
                        </dual-listbox>
                    </div>
                </div>
                <!-- Save/cancel/remove buttons -->
                <SubmitCancelRemove
                    :is-saving="isSaving"
                    :is-deleting="isDeleting"
                    :mode="mode"
                    :isBtnSaveDisabled="isBtnSaveDisabled"
                    @cancel="$_onCancel"
                >
                </SubmitCancelRemove>
            </div>
        </b-form>
        <control-data-record-modal
            :controlDataRecord="controlDataRecord"
            :controlDataRecords="controlDataRecords"
            :launchModal="launchModal"
            @save="$_onAddControlDataRecord($event)"
        >
        </control-data-record-modal>
    </div>
</template>

<script>
    /* Store imports */
    import { mapGetters } from 'vuex';
    import {
        INPUT_TYPE,
        API_URL_TYPE,
        EXTERNAL_API_TYPE,
        KADASTRALEGEMEENTECODES
    } from '../../constants';
    import XInput from '../../components/BaseComponents/x-input.vue';
    import DualListBox from '../../components/DualListBox.vue';
    import CertificateLoader from '../../components/CertificateLoader.vue';
    import SubmitCancelRemove from '../../components/SubmitCancelRemove.vue';
    import modalMixin from '../../components/Mixins/ModalMixin.vue';
    import UsernamePassword from '../../components/UsernamePassword.vue';
    import controlDataRecordModal from './ControlDataRecordModal.vue';

    export default {
        name: 'ApiSettingsDetail',
        mixins: [modalMixin],

        components: {
            SubmitCancelRemove,
            'x-input': XInput,
            'dual-listbox': DualListBox,
            'certificate-loader': CertificateLoader,
            'username-password': UsernamePassword,
            'control-data-record-modal': controlDataRecordModal
        },

        props: {
            // Api id
            id: { type: Number, default: -1 }
        },

        data: function () {
            return {
                mode: 0,
                title: '',
                orgApiSettings: {
                    id: -1,
                    organizationId: -1,
                    apiId: -1,
                    apiKey: '',
                    apiName: '',
                    certificate: null,
                    certPass: '',
                    licensed: false
                },
                apiTypeSetting: {},
                inputType: INPUT_TYPE.Password,
                eyeIcon: false,
                hasSavedPassword: false,
                passwordIsChanged: false,
                kadastraleGemeenteCodes: [],
                // validation
                errorInUse: false,
                nameMessage: '',
                isSaving: false,
                isDeleting: false,
                isLoading: false,
                controlDataRecords: [],
                controlDataRecordNewId: 0,

                fields: [
                    {
                        key: 'gemeenteNaam',
                        label: this.$t('columnNameName'),
                        sortable: true,
                        thStyle: {
                            border: 0
                        }
                    },
                    {
                        key: 'receiverApplicationName',
                        label: this.$t('apiSettings.receiverApplicationName'),
                        sortable: true,
                        thStyle: {
                            border: 0
                        }
                    },

                    {
                        key: 'senderApplicationName',
                        label: this.$t('apiSettings.senderApplicationName'),
                        sortable: true,
                        thStyle: {
                            border: 0
                        }
                    },
                    {
                        key: 'senderOrganizationName',
                        label: this.$t('apiSettings.senderOrganizationName'),
                        sortable: true,
                        thStyle: {
                            border: 0
                        }
                    },
                    {
                        key: 'delete',
                        label: '',
                        sortable: false,
                        tdClass: 'align-middle'
                    }
                ],
                sortBy: '',
                controlDataRecord: {},
                launchModal: false
            };
        },

        computed: {
            ...mapGetters(['getLocale']),
            showCertificate() {
                // Show certificate when Api Type has a certificate
                // and this is not an optional certificiate
                // or for this instance the certificate is required.
                return (
                    this.apiTypeSetting.hasCertificate &&
                    (!this.apiTypeSetting.certificateIsOptional ||
                        this.orgApiSettings.certificateIsRequired)
                );
            },

            showBaseUrl() {
                return this.apiTypeSetting.urlType === API_URL_TYPE.BASE;
            },

            editUrl() {
                // URL can be edited for the organization API when
                // The API type has an URL type ORGANIZATION
                // or the URL type is BASE and canoverruleBaseUrl is true
                return (
                    this.apiTypeSetting.urlType === API_URL_TYPE.ORGANIZATION ||
                    this.orgApiSettings.canOverruleBaseUrl
                );
            },

            urlTitle() {
                if (this.apiTypeSetting.urlType === API_URL_TYPE.ORGANIZATION) {
                    return this.$t('apiSettings.urlTitle');
                } else {
                    return this.$t('apiSettings.urlOptionalTitle');
                }
            },

            showEyeIcon() {
                return !this.hasSavedPassword || this.passwordIsChanged;
            },

            certSelected: function () {
                return this.orgApiSettings.hasCertificate;
            },

            certStatus: function () {
                if (this.certSelected) {
                    return this.$t('apiSettings.selectedCertificateTitle');
                } else {
                    return this.$t('apiSettings.unSelectedCertificateTitle');
                }
            },

            isWoz() {
                return this.orgApiSettings?.apiType === EXTERNAL_API_TYPE.WOZ;
            },

            availableGemCodes() {
                return this.kadastraleGemeenteCodes.filter((o) => !o.userEnabled);
            },

            selectedGemCodes() {
                return this.kadastraleGemeenteCodes.filter((o) => o.userEnabled);
            },

            /**
             * Check if connection license can be saved
             * @returns {boolean} indicating if organization can be saved
             */
            isBtnSaveDisabled: function () {
                return this.isSaving || this.isDeleting;
            }
        },

        async created() {
            await this.$_getOrgApiSettings();
            if (this.isWoz) {
                this.$_getKadastraleGemeenteCodes();
            }
        },

        methods: {
            async $_getOrgApiSettings() {
                this.isLoading = true;
                try {
                    const apiSettingsResult = await this.$store.dispatch(
                        'useApiData',
                        {
                            name: 'GetOrganizationApiSettings',
                            parameters: { ApiId: this.id }
                        }
                    );
                    this.orgApiSettings = Object.assign({}, apiSettingsResult.data);
                    // Determine whether record has saved password
                    this.hasSavedPassword = this.$_hasPassword();
                    await this.$_getApiTypeSetting();
                    if (this.apiTypeSetting.hasStufFields) {
                        await this.$_getOrganizationApiControlDataRecords(
                            this.orgApiSettings.id
                        );
                        this.$_getKadastraleGemeenteCodes();
                    }
                } catch (error) {
                    const data = {
                        message: error.message,
                        variant: 'danger',
                        title: this.$t('apiSettings.errorGetApiSettings'),
                        autoHideDelay: 5000
                    };
                    this.showToast(data);
                } finally {
                    this.isLoading = false;
                }
            },

            async $_getApiTypeSetting() {
                // Get the API type settings for this API's type
                try {
                    const apiSettingsResult = await this.$store.dispatch(
                        'useApiData',
                        { name: 'GetApiTypeSettings' }
                    );

                    this.apiTypeSetting = apiSettingsResult.data.find(
                        (a) => a.apiType === this.orgApiSettings.apiType
                    );
                } catch (error) {
                    const data = {
                        message: error.message,
                        variant: 'danger',
                        title: this.$t('apiSettings.errorGetApiTypeSettings'),
                        autoHideDelay: 5000
                    };
                    this.showToast(data);
                }
            },

            async $_getOrganizationApiControlDataRecords(id) {
                // Get the API type settings for this API's type
                try {
                    const result = await this.$store.dispatch('useApiData', {
                        name: 'GetOrganizationApiControlDataRecords',
                        parameters: { organizationApiSettingId: id }
                    });

                    this.controlDataRecords = result.data;
                } catch (error) {
                    const data = {
                        message: error.message,
                        variant: 'danger',
                        title: this.$t('apiSettings.errorGetApiTypeSettings'),
                        autoHideDelay: 5000
                    };
                    this.showToast(data);
                }
            },

            $_onInputApiKey(input) {
                this.orgApiSettings.apiKey = input;
            },

            $_onSelectedCertificate(value) {
                this.orgApiSettings.hasCertificate = false;
                if (value && value.length > 0) {
                    this.orgApiSettings.hasCertificate = true;
                    // Use ascii to convert to base64, because 'value' is from a byte array and not a utf-8 string
                    this.orgApiSettings.certificate = Buffer.from(
                        String.fromCharCode.apply(null, value),
                        'ascii'
                    ).toString('base64');
                }
            },

            $_onLoadFileValidState(validState) {
                this.orgApiSettings.hasCertificate = validState;
                if (!validState) {
                    this.orgApiSettings.certificate = null;
                }
            },

            $_onInputPassword(input) {
                this.orgApiSettings.certificatePass = input;
                this.passwordIsChanged = true;
            },

            $_hasPassword() {
                return this.orgApiSettings?.certPass?.length > 0;
            },

            $_togglePassword() {
                this.inputType =
                    this.inputType === INPUT_TYPE.Text
                        ? INPUT_TYPE.Password
                        : INPUT_TYPE.Text;
                this.eyeIcon = this.inputType === INPUT_TYPE.Text;
            },

            $_goToOverview() {
                this.$router.push({
                    path: '/dashboard/OrganizationApisettingsOverview'
                });
            },

            $_onCancel: function () {
                this.$_goToOverview();
            },

            async $_onSave() {
                this.isSaving = true;

                const name = this.id
                    ? 'UpdateOrganizationApiSettings'
                    : 'CreateOrganizationApiSettings';
                const parameters = { Id: this.orgApiSettings.id };
                const kadastraleGemeenteCode = this.isWoz
                    ? this.selectedGemCodes.map((item) => item.id).join(',')
                    : '';

                try {
                    // make sure not to send an empty string to the database but a null value
                    if (this.orgApiSettings.apiKeyEndDate === '') {
                        this.orgApiSettings.apiKeyEndDate = null;
                    }
                    await this.$store.dispatch('useApiData', {
                        name,
                        parameters,
                        data: {
                            ...this.orgApiSettings,
                            kadastraleGemeenteCode
                        }
                    });

                    // Save controlDataRecords (for Stuf only)
                    if (this.apiTypeSetting.hasStufFields) {
                        await this.$store.dispatch('useApiData', {
                            name: 'SaveOrganizationApiControlDataRecords',
                            data: {
                                OrganizationApiSettingId: this.orgApiSettings.id,
                                OrganizationApiControlDataRecords:
                                    this.controlDataRecords
                            }
                        });
                    }
                    const data = {
                        message: this.$t('apiSettings.saved'),
                        variant: 'success',
                        autoHideDelay: 5000
                    };
                    this.showToast(data);
                    this.$_goToOverview();
                } catch (error) {
                    const data = {
                        message: this.$t(error.message),
                        variant: 'danger',
                        title: this.$t(error.title),
                        autoHideDelay: 5000
                    };
                    this.showToast(data);
                }
                this.isSaving = false;
            },

            $_onSubmit() {
                if (this.showCertificate && !this.orgApiSettings.hasCertificate) {
                    const data = {
                        message: this.$t('apiSettings.unSelectedCertificateTitle'),
                        variant: 'danger',
                        title: this.$t('apiSettings.titleOrganizationApiSettings'),
                        autoHideDelay: 5000
                    };
                    this.showToast(data);
                } else if (this.$refs.apiSettingsForm.checkValidity()) {
                    this.$_onSave();
                }
            },

            $_getKadastraleGemeenteCodes() {
                const gemCodes =
                    this.orgApiSettings.kadastraleGemeenteCode?.split(',');

                this.kadastraleGemeenteCodes = KADASTRALEGEMEENTECODES.map(
                    (item) => {
                        return {
                            id: item.Code,
                            text: `${item.Toelichting} (${item.Waarde})`,
                            userEnabled:
                                gemCodes?.includes(item.Code.toString()) ?? false
                        };
                    }
                );
            },

            $_onEditRecord(event) {
                this.controlDataRecord = event;
                this.launchModal = !this.launchModal;
            },

            $_onAddRecord() {
                this.controlDataRecordNewId = this.controlDataRecordNewId - 1;
                this.controlDataRecord = { id: this.controlDataRecordNewId };
                this.launchModal = !this.launchModal;
            },
            $_onDeleteRecord(item) {
                const index = this.controlDataRecords.findIndex(
                    (r) => r.id === item.id
                );
                if (index !== -1) {
                    this.controlDataRecords.splice(index, 1);
                }
            },
            $_onAddControlDataRecord(event) {
                const existing = this.controlDataRecords.find(
                    (r) => r.id === event.id
                );

                if (existing) {
                    Object.assign(existing, event); // Update existing record
                } else {
                    this.controlDataRecords.push(event); // Add new record
                }
            },

            $_rowClass() {
                return 'tablerow';
            },

            $_updateKadastraleGemeenteCodes(event) {
                this.kadastraleGemeenteCodes = event;
            }
        }
    };
</script>

<style scoped>
.btn-field {
    color: #212529;
    overflow: visible;
    border: 0;
    padding: 0;
    cursor: pointer;
    width: 20px;
    height: 20px;
    position: absolute;
    z-index: 4;
    right: 26px;
    top: 7px;
    background: transparent;
}

.btn-field .no-action {
    cursor: text;
}

.max_width {
    width: 100%;
}
.delete {
    color: red;
    padding-left: 0.2em;
    padding-right: 0.2em;
}
</style>
